import { apiSlice, publicApiSlice } from "../../apiSlice";
import { createProjectApi } from "./createProjectApi";

// Define separate tag types for fast and detailed views
const projectTags = {
	FAST_LIST: 'FastProjects' as const,
	FAST_DETAIL: (id: number) => ({ type: 'FastProjects' as const, id }),
	DETAIL_LIST: 'DetailedProjects' as const,
	DETAIL: (id: number) => ({ type: 'DetailedProjects' as const, id })
};

// Create both private and public API slices
export const projectApiSlice = createProjectApi(apiSlice);
export const publicProjectApiSlice = createProjectApi(publicApiSlice);

// Export hooks for private API
export const {
	useGetProjectByIdQuery,
	useLazyGetProjectByIdQuery,
	useGetProjectResultsQuery,
	useGetProjectResultsByGasQuery,
	useGetSOCrefQuery,
	useCreateProjectMutation,
	useUpdateProjectMutation,
	useDeleteProjectMutation,
	useCreateProjectCopyMutation,
	useGetProjectMembershipsQuery,
	useDeleteMembershipMutation,
	useGetProjectsQuery,
	useUploadProjectAttachmentMutation,
	useDeleteProjectAttachmentMutation,
	useGetProjectAttachmentsQuery,
	useLazyDownloadProjectAttachmentQuery,
	useLazyGetMyMembershipsQuery,
	useLazyDownloadProjectReportQuery,
	useLazyExportProjectQuery,
	useFinalizeProjectMutation,
	useGetAllTagsQuery,
	useAddTagToProjectMutation,
	useDeleteTagFromProjectMutation,
	useGetTagsByProjectQuery,
	useMoveToTrashbinMutation,
	useUploadMapDataMutation,
	useTogglePublicProjectMutation,
	useGetProjectLockInfoQuery,
	useLazyGetProjectLockInfoQuery,
	useToggleProjectLockMutation,
	useCopyProjectAsyncMutation,
	useTriggerAsyncReportMutation,
	useImportProjectMutation,
	endpoints,
} = projectApiSlice;

// Export hooks for public API - only read operations
export const {
	useGetProjectByIdQuery: usePublicGetProjectByIdQuery,
	useLazyGetProjectByIdQuery: useLazyPublicGetProjectByIdQuery,
	useGetProjectResultsQuery: usePublicGetProjectResultsQuery,
	useGetProjectResultsByGasQuery: usePublicGetProjectResultsByGasQuery,
	useGetSOCrefQuery: usePublicGetSOCrefQuery,
	useGetProjectMembershipsQuery: usePublicGetProjectMembershipsQuery,
	useGetProjectsQuery: usePublicGetProjectsQuery,
	useGetProjectAttachmentsQuery: usePublicGetProjectAttachmentsQuery,
	useLazyDownloadProjectAttachmentQuery: useLazyPublicDownloadProjectAttachmentQuery,
	useLazyGetMyMembershipsQuery: useLazyPublicGetMyMembershipsQuery,
	useLazyDownloadProjectReportQuery: useLazyPublicDownloadProjectReportQuery,
	useGetAllTagsQuery: usePublicGetAllTagsQuery,
	useGetTagsByProjectQuery: usePublicGetTagsByProjectQuery,
	useGetProjectLockInfoQuery: usePublicGetProjectLockInfoQuery,
} = publicProjectApiSlice;
